//angular imports
import {
    ChangeDetectionStrategy,
    Component, 
    WritableSignal, 
    signal,
} from '@angular/core';

//local imports
import { PresenterType } from '@shared/components';
import { RoomAddedMessage } from './room-added.message';

@PresenterType(
{
    model: RoomAddedMessage
})
@Component({
    selector: 'room-added-message-template',
    templateUrl: './room-added-message-template.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class RoomAddedMessageTemplateComponent
{
    public data: WritableSignal<RoomAddedMessage>;
    
    constructor() {
        this.data = signal<RoomAddedMessage>(null);
    }
}